<template>
  <section class="container section pt-0">
    <api-key-datatable />
  </section>
</template>

<script>
import ApiKeyDatatable from "./api_key_datatable/Index.vue";

export default {
  name: "ApiKeys",
  components: { ApiKeyDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
